import { Alert, Button, Card, Col, Form, Input, Row } from "antd";
import React, { Component, useEffect } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../helpers/constant";
import { InfoCircleFilled } from "@ant-design/icons";

const Payment = () => {
  const listItem = [
    {
      id: 1,
      icon: "fa fa-check",
      title: "Proven Tax-Saving Strategies",
    },
    {
      id: 2,
      icon: "fa fa-check",
      title: "Maximize Deductions",
    },
    {
      id: 3,
      icon: "fa fa-check",
      title: "Step-by-Step Guidance",
    },
    {
      id: 4,
      icon: "fa fa-check",
      title: "Compliant with tax laws",
    },
  ];

  const [form] = Form.useForm();

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  function downloadPdf(pdfLink) {
    const link = document.createElement("a");
    link.href = pdfLink;
    link.download =
      "Best-Tax-Saving-Strategies-for-Salaried-Individuals-FY-2024-25.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up
  }

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on mount
  }, []);

  const finish = () => {
    form.validateFields().then(async (values) => {
      const res = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );

      if (!res) {
        alert("Razropay failed to load!!");
        return;
      }

      const data = await fetch(`${API_URL}/payment/create-order`, {
        method: "POST",
        body: JSON.stringify({
          // name: values.name,
          email: values.email,
          //mobile: values.mobile,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      }).then((t) => t.json());

      const options = {
        key: data.data.key,
        amount: data.data.amount,
        currency: "INR",
        name: "ExpertEdge Publication",
        description: "Buy E-book",
        // image: "https://example.com/your_logo",
        order_id: data.data.order_id,
        // callback_url: "http://localhost:4000/verify",
        theme: {
          color: "#3399cc",
        },
        handler: async function (response) {
          var successData = {
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
          };
          const result = await fetch(`${API_URL}/payment/verify-pament`, {
            //Accept: "application/json",
            method: "POST",
            body: JSON.stringify(successData),
            headers: {
              "Content-Type": "application/json",
            },
          }).then((t) => t.json());
          console.log(result);

          // const get_pdf = await fetch(result.data.link, {
          //   method: "GET",
          // }).then((t) => t.json());
          downloadPdf(result.data.link);

          //window.open(result.data.link);
          // console.log(get_pdf);
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    });
  };

  return (
    <section className="banner pb-80 dark-bg">
      <div className="container">
        <div className="col-lg-12">
          <div className="section-heading center-heading text-center mb-60">
            <h3 className="heading-title">ExpertEdge Publications</h3>
            <p>Your Gateway to Knowledge and Expertise</p>
          </div>
        </div>
        <div className="row align-items-center justify-content-between">
          <div className="col-lg-6">
            <Card title="Payment Amount: ₹ 99">
              <Form layout="vertical" form={form} onFinish={finish}>
                <Row gutter={16}>
                  {/* <Col span={24}>
                    <Form.Item
                      name="name"
                      label="Name"
                      rules={[
                        { required: true, message: "Name is required." },
                        {
                          max: 200,
                          message: "Name should be maximum of 200 characters.",
                        },
                      ]}
                    >
                      <Input placeholder="Name" className="form-control" />
                    </Form.Item>
                  </Col> */}
                  {/*<Col span={24}>
                    <Form.Item
                      name="mobile"
                      label="Mobile"
                      rules={[
                        { required: true, message: "Mobile is required." },
                        {
                          max: 100,
                          message:
                            "Mobile should be maximum of 100 characters.",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Mobile Number"
                        className="form-control"
                      />
                    </Form.Item>
                  </Col>*/}
                  <Col span={24}>
                    <Form.Item
                      name="email"
                      label="Email"
                      rules={[
                        { required: true, message: "Email is required." },
                        {
                          max: 100,
                          message: "Email should be maximum of 100 characters.",
                        },
                      ]}
                    >
                      <Input placeholder="Email" className="form-control" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{ paddingBottom: 20, color: "gray" }}>
                  <Col span={24}>
                    <label>
                      <InfoCircleFilled /> Please enable pop-ups in your browser
                      before proceding with payment.
                    </label>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        style={{ float: "right", paddingBottom: 36 }}
                        className="btn btn-main-2"
                      >
                        PAY NOW
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Card style={{ marginBottom: "10px" }}>
                    <Row>
                      Our eBook will be sent to your registered email within a
                      few minutes. Please check your inbox (and spam/junk
                      folder, if needed). If you do not receive the eBook ,
                      please contact us at expertedgepublications@gmail.com or
                      7219509422
                    </Row>
                    <Row>Happy reading!</Row>
                  </Card>
                </Row>
                <Row>
                  <Alert
                    message="Copyright Notice"
                    description={
                      <>
                        <Row>
                          This eBook is protected by copyright law. Unauthorized
                          sharing, forwarding, reproduction, or distribution of
                          this eBook, in whole or in part, via social media,
                          email, or any other platform is strictly prohibited.
                          Any violation may result in legal action under
                          applicable copyright laws.
                        </Row>
                        <Row>
                          Thank you for respecting intellectual property rights.
                        </Row>
                      </>
                    }
                    type="info"
                    // showIcon
                  />
                </Row>
              </Form>
            </Card>
          </div>
          <div className="col-md-12 col-lg-6">
            <div className="banner-content  mt-4 mt-lg-0">
              <span className="subheading">ExpertEdge Publication's</span>
              <h1>
                The Ultimate Tax-Saving Strategies for Salaried Individuals
              </h1>
              <ul>
                {listItem.map((data) => (
                  <li key={data.id}>
                    <i className={data.icon}></i> {data.title}
                  </li>
                ))}
              </ul>
              {/* <Link to="/payment" className="btn btn-main">Get this book at  ₹ 99</Link> */}
              {/* <p>Interested in free chapter? <Link to="#">Get it now</Link></p> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Payment;
